<div class="pacientes-container white-panel" #rootElement>
    <div class="container">
        <div class="row">
            <div class="col-6">
                <img src="https://api.bealign.com/img/contenidos/7.jpg" class="img-fluid" />
            </div>
            <div class="col-6">
                <img src="https://api.bealign.com/img/contenidos/8.jpg" class="img-fluid" />
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-6">
                <img src="https://api.bealign.com/img/contenidos/9.jpg" class="img-fluid" />
            </div>
            <div class="col-6">
                <img src="https://api.bealign.com/img/contenidos/10.jpg" class="img-fluid" />
            </div>
        </div>
    </div>
</div>